import { render, staticRenderFns } from "./openData.vue?vue&type=template&id=1a7f6cf9&scoped=true"
import script from "./openData.vue?vue&type=script&lang=js"
export * from "./openData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7f6cf9",
  null
  
)

export default component.exports